import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import Link from "components/Shared/Link";
import MaybeButtonLink from "components/Shared/MaybeButtonLink";
import { NameWithFlagIcons } from "components/Shared/RetailerDirectory/utils";
import { Url } from "utils/links";

const fragment = gql(/* GraphQL */ `
  fragment MaybeRetailerLinkFragment on Retailer {
    id
    ...RetailerNameWithFlagIconsFragment
  }
`);

type Props = {
  href?: Url;
  onClick?: (retailerId: UUID) => void;
  retailer: FragmentType<typeof fragment> | null | undefined;
};

export default function MaybeRetailerLink({
  href,
  onClick,
  retailer: retailerFragment,
}: Props) {
  const retailer = getFragmentData(fragment, retailerFragment);

  if (href) {
    return (
      <Link
        href={href}
        onClick={
          onClick && retailer
            ? (e) => {
                e.preventDefault();
                onClick(retailer.id);
              }
            : undefined
        }
      >
        <NameWithFlagIcons retailer={retailer} />
      </Link>
    );
  }

  return (
    <MaybeButtonLink
      onClick={
        onClick && retailer
          ? () => {
              onClick(retailer.id);
            }
          : undefined
      }
    >
      <NameWithFlagIcons retailer={retailer} />
    </MaybeButtonLink>
  );
}
